import {
  IObservableArray,
  computed,
  makeAutoObservable,
  observable,
} from "mobx";
import NewsServerClient from "../ServerClients/NewsServerClient";
import {
  EmptyNewsItemPropImpl,
  NewsItemResponseApi,
} from "../DTO/ServerResponseType/News/NewsItem";
import { SaveStoreApi } from "./API/SaveStore";
import { CheckArgs } from "../utils/checks/CheckArgsWithoutThrow";
import ImageDTO, { ImageDTOApi } from "../DTO/Image/ImageDTO";
import NewsImageDTO from "../DTO/Image/NewsImageDTO";

export class NewsItemStore implements SaveStoreApi {
  public newsItem: NewsItemResponseApi;
  public isAddPreviewTextToHtml: boolean = false;
  public newsImages: IObservableArray<ImageDTOApi>;
  public withNavigationAfterSaving: boolean = true;

  constructor() {
    this.newsItem = new EmptyNewsItemPropImpl();
    this.newsImages = observable.array([]);
    makeAutoObservable(this);
  }
  public onChangeId = (newsId: string) => {
    this.newsItem.newsId = newsId;
  };
  public onChangeTitle = (event: React.FormEvent<HTMLInputElement>) => {
    this.newsItem.newsTitle = event.currentTarget.value;
  };
  public onChangePreviewText = (
    event: React.FormEvent<HTMLTextAreaElement>
  ) => {
    this.newsItem.newsPreviewText = event.currentTarget.value;
  };

  public setIsAddPreviewTextToHtml = (
    event: React.FormEvent<HTMLInputElement>
  ) => {
    this.isAddPreviewTextToHtml = event.currentTarget.checked;
  };

  public setId = (newsId: string) => {
    this.newsItem.newsId = newsId;
  };

  public addPreviewTextToHtml = () => {
    this.newsItem.newsHtml =
      "<div><p>" +
      this.newsItem.newsPreviewText +
      "</p>" +
      this.newsItem.newsHtml +
      "</div>";
  };

  public onChangeAuthor = (event: React.FormEvent<HTMLInputElement>) => {
    this.newsItem.newsAuthor = event.currentTarget.value;
  };
  public onChangeHtml = (event: React.FormEvent<HTMLTextAreaElement>) => {
    this.newsItem.newsHtml = event.currentTarget.value;
  };
  public onChangeDate = (event: React.FormEvent<HTMLInputElement>) => {
    this.newsItem.newsDate = event.currentTarget.value;
  };

  /**
   * Add image to store and to database on the server
   * @param event
   * @returns
   */
  public addImageFromFileAsync = async (
    event: React.FormEvent<HTMLInputElement>
  ) => {
    // File was not selected
    if (event.currentTarget.files === null) return;

    // News item was not created
    if (CheckArgs.CheckNullOrUndefinedOrEmptyString(this.newsItem.newsId))
      return;

    let file = event.currentTarget.files[0];
    return await NewsServerClient.sendToCreateNewsItemImageAsync(
      this.newsItem.newsId,
      file
    )
      .then((newsImageId: string) => {
        this.newsImages.push(
          new ImageDTO({
            id: newsImageId,
            src: URL.createObjectURL(file),
          })
        );
      })
      .catch((error) => {
        console.error("Ошибка:", error);
      });
  };

  public deleteImage = (imageId: string) => {
    NewsServerClient.sendToDeleteNewsImageAsync(imageId).then(() => {
      this.newsImages.replace(
        this.newsImages.filter(
          (image: ImageDTOApi) => image.imageId !== imageId
        )
      );
    });
  };

  public setNewsItem = (newsItem: NewsItemResponseApi) => {
    this.newsItem = newsItem;

    this.newsImages.replace(
      Array.from(newsItem.newsImages, (image) => new NewsImageDTO(image))
    );
  };

  @computed get saveWindowTitle(): string {
    return this.newsItem.newsId === ""
      ? "Создание новости"
      : "Обновление новости";
  }

  @computed get saveButtonText(): string {
    return this.newsItem.newsId === "" ? "Создать новость" : "Обновить новость";
  }

  @computed get newsAllowImages(): boolean {
    return this.newsItem.newsId !== "";
  }

  @computed get saveClickAsync() {
    if (this.isAddPreviewTextToHtml === true) {
      this.addPreviewTextToHtml();
    }

    return this.newsItem.newsId === ""
      ? NewsServerClient.sendToCreateNewsAsync(this)
      : NewsServerClient.sendToUpdateNewsAsync(this);
  }

  public loadNewsItemAsync = async (
    newsId: string
  ): Promise<NewsItemResponseApi | never> => {
    return NewsServerClient.sendToGetNewsItemByNewsItemIdAsync(newsId).then(
      (newsItem) => {
        this.setNewsItem(newsItem);
        return newsItem;
      }
    );
  };

  public loadNewNewsItemAsync = async (): Promise<NewsItemResponseApi> => {
    let newsItem = new EmptyNewsItemPropImpl();
    newsItem.newsDate = new Date().toISOString().split("T")[0];
    return newsItem;
  };
}
